<template>
  <div class="chats">
    <div
      v-if="isFriendTyping"
      class="w-100"
    >
      <div
        class="chat chat-left"
      >
        <div class="chat-avatar">
          <b-avatar
            size="36"
            class="avatar-border-2 box-shadow-1"
            variant="primary"
            :text="avatarText(activeRoom.user_1.name)"
          />
        </div>
        <div class="chat-body">
          <div
            class="chat-content"
          >
            <div class="ticontainer">
              <div class="tiblock">
                <div class="tidot" />
                <div class="tidot" />
                <div class="tidot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-for="item in $store.state.chat.messages"
      :key="`chat-bubble-${item.id}`"
      class="w-100"
    >
      <div
        class="chat"
        :class="{'chat-left': activeRoom.user_1.id === item.sender_id}"
      >
        <div class="chat-avatar">
          <b-avatar
            v-show="activeRoom.user_1.id === item.sender_id"
            size="36"
            class="avatar-border-2 box-shadow-1"
            variant="primary"
            :src="linkStaging($store.state.chat.activeRoom.user_1.photo_url, 36, 36)"
            :text="avatarText(activeRoom.user_1.name)"
          />

          <b-avatar
            v-show="activeRoom.user_1.id !== item.sender_id"
            size="36"
            class="cursor-pointer badge-minimal avatar-border-2"
            src="@/assets/images/logo/favicon.png"
            variant="transparent"
            badge
            badge-variant="success"
          />
        </div>
        <div class="chat-body">
          <div
            v-if="activeRoom.user_1.id === item.sender_id"
            class="ml-1 mb-25 font-weight-bold"
          >
            {{ activeRoom.user_1.name }}
          </div>
          <div
            class="chat-content"
          >
            <div
              v-if="item.is_auto_answered"
              class="text-nowrap opacity-half s-12 mb-25"
            >
              Auto Reply
            </div>
            <p
              v-if="activeRoom.user_1.id !== item.sender_id"
              v-html="item.message"
            />
            <p v-else>
              {{ item.message }}
            </p>
            <div
              v-if="item.created_at"
              class="text-nowrap opacity-half s-12 mb-n25 mt-25 d-flex align-items-center"
              :class="{'text-right': activeRoom.user_1.id !== item.sender_id}"
            >
              <img
                v-if="item.id && activeRoom.user_1.id === item.sender_id"
                width="16"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAi0lEQVR4nO2RwQ2AIBAEpwmJPG3CnrA/GwET+7ABjcYHMaAcBv2wzwmZ5e6gpubvKMAIuFjugBUYErgoDWBPyQy0D1z8c1tS7r6Sa4ncnII73gMLMHnML3URx3Hp0IMQ76Xy0Ij6gWftXFLS5B40NrK68KS1pJSMEZ4t92W7vIuUv5KnlKtS8hqKZAOmMUyTiuIjcQAAAABJRU5ErkJggg=="
              >
              <img
                v-else-if="activeRoom.user_1.id === item.sender_id"
                width="16"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAa0lEQVR4nO2SQQ6AIAwE5xMQfSI81x54Dl4wIYpBAzUeOmeYwnbBMF7igaApFyADcbbcAVuRJ2Ax+b9jCaURT9oinbMXYueiH5G3vr5qZN4a4mYv9ByFjMRyR/3qrFHFekjSkB/4mbEY37MDq8wwEEHSl/sAAAAASUVORK5CYII="
              >
              <img
                v-else-if="item.id && activeRoom.user_1.id !== item.sender_id"
                width="16"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAkklEQVR4nO2RwQmEMBBF04TBHG1ie9L+bMQI9rENPAlRkDCYMa542PzjY3jDzDempubVABbotbxE7okZcvyqvAGmTbIA7Rn/X7lTy0PjoZwzDnyALzAf2LFQLznC0CANSJy4RC+/eLrLdfGL/7riQreTZ+EtNnlF/i3KJWPCd3GZPJGNQCdwf0uuXG4fkdeYp7ICMxv09RY42L8AAAAASUVORK5CYII="
              >
              <img
                v-else
                width="16"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAbElEQVR4nO2SQQ6AIAwE+YREnwjPtQeeM8boiVSCWoyHzplO02VDcJw7ABFII+XCQbaWT8B6ygswuzz8NxYg7Y3obIu03mrDuTXIG/nF6Yt55toSrD9UiUIex9J5iX0VqyXFXF7FFYfInU/YACecNBrPmY0rAAAAAElFTkSuQmCC"
              >
              <span class="ml-25">{{ formatDateToMonthShort(item.created_at, { hour: 'numeric', minute: 'numeric' }) }}</span>
            </div>
          </div>
        </div>
      </div>

      <b-form-row
        v-if="item.is_auto_answered && item.pending"
        class="justify-content-end mr-3 pr-25 mb-1"
      >
        <b-col cols="auto">
          <b-button
            variant="danger"
            @click="$emit('cancel-reply', item)"
          >
            Cancel
          </b-button>
        </b-col>
      </b-form-row>
    </div>

    <div class="text-center pb-1">
      <b-button
        v-if="$store.state.chat.messagesMeta
          && $store.state.chat.messagesMeta.current_page
            !== $store.state.chat.messagesMeta.last_page"
        variant="primary"
        :disabled="$store.state.chat.isLoadingMessages"
        class="d-flex align-items-center mx-auto"
        @click="loadNextChats"
      >
        <b-spinner
          v-if="$store.state.chat.isLoadingMessages"
          small
          label="Spinning"
          class="mr-50"
        />
        Lihat lebih banyak
      </b-button>
      <span
        v-else-if="$store.state.chat.messagesMeta"
        class="text-primary px-1 py-50 rounded-lg bg-primary-blur d-inline-block mx-auto"
      >Menampilkan seluruh percakapan</span>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
  BAvatar, BFormRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import { avatarText, formatDateToMonthShort } from '@core/utils/filter'

export default {
  components: {
    BSpinner,
    BAvatar,
    BFormRow,
    BCol,
    BButton,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      default: '',
    },
    isFriendTyping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avatarText,
      formatDateToMonthShort,
    }
  },
  computed: {
    activeRoom() {
      return this.$store.state.chat.activeRoom
    },
  },
  methods: {
    loadNextChats() {
      if (this.$store.state.chat.messagesMeta
        && this.$store.state.chat.messagesMeta.current_page
        !== this.$store.state.chat.messagesMeta.last_page) {
        this.$store.dispatch('chat/getChat', {
          roomId: this.$store.state.chat.activeRoom.id,
          page: this.$store.state.chat.messagesMeta.current_page + 1,
        })
      }
    },
  },
  setup(props) {
    const formattedChatData = computed(() => {
      const contact = {
        id: props.chatData.contact.id,
        avatar: props.chatData.contact.avatar,
      }

      let chatLog = []
      if (props.chatData.chat) {
        chatLog = props.chatData.chat.chat
      }

      const formattedChatLog = []
      let chatMessageSenderId = chatLog[0] ? chatLog[0].senderId : undefined
      let msgGroup = {
        sender: chatMessageSenderId,
        messages: [],
      }

      chatLog.forEach((msg, index) => {
        if (chatMessageSenderId === msg.senderId) {
          msgGroup.messages.push({
            msg: msg.message,
            time: msg.time,
          })
        } else {
          chatMessageSenderId = msg.senderId
          formattedChatLog.push(msgGroup)
          msgGroup = {
            senderId: msg.senderId,
            messages: [{
              msg: msg.message,
              time: msg.time,
            }],
          }
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup)
      })

      return {
        formattedChatLog,
        contact,
        profileUserAvatar: props.profileUserAvatar,
      }
    })

    return {
      formattedChatData,
    }
  },
}
</script>

<style>
.chats {
  flex-flow: column-reverse;
  display: flex;
  position: absolute;
  bottom: 0;
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  width: calc(100% - 1rem);
}

.tiblock {
  align-items: center;
  display: flex;
  height: 17px;
}

.chat-content a {
  color: white;
  font-weight: 700;
  text-decoration: underline;
}

.ticontainer .tidot {
  background-color: #90949c;
}

.tidot {
  -webkit-animation: mercuryTypingAnimation 1.5s infinite ease-in-out;
  border-radius: 2px;
  display: inline-block;
  height: 4px;
  margin-right: 2px;
  width: 4px;
}

@-webkit-keyframes mercuryTypingAnimation{
  0%{
    -webkit-transform:translateY(0px)
  }
  28%{
    -webkit-transform:translateY(-5px)
  }
  44%{
    -webkit-transform:translateY(0px)
  }
}

.tidot:nth-child(1){
  -webkit-animation-delay:200ms;
}
.tidot:nth-child(2){
  -webkit-animation-delay:300ms;
}
.tidot:nth-child(3){
  -webkit-animation-delay:400ms;
}
</style>
